import { rdcManual, deviceInventoryService } from '@saucelabs/sl-util-axios';

export const fetchPrivateDevices = (payload) => {
  const endpoint = rdcManual[payload.dataCenterId];
  return endpoint.get('/rdc/device/filtered', {
    params: payload,
  });
};

export const fetchDevicesToTeams = (payload) => deviceInventoryService.get('/v1/rdc/teams-devices', {
  params: payload,
});
